export const scrollUpButtonStyles = {
	root: {
		position: 'fixed',
		bottom: 20,
		right: 20,
		opacity: 0.85,
		backgroundColor: 'orange.main',

		'&:hover': {
			backgroundColor: 'orange.light'
		}
	},

	icon: {
		color: 'orange.contrastText'
	}
};
